import React, { useState, useEffect, useRef } from 'react'

import {

    Button, Dialog, Grid, Icon, Typography
} from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements'
import { withSnackbar } from "../../../../components/Message/Alert";
import useStyles from "./styles";
import Tooltip from '@material-ui/core/Tooltip';
import SimCardIcon from '@material-ui/icons/SimCard';
import SignalCellularNoSimIcon from '@material-ui/icons/SignalCellularNoSim';
import { PostDataAPI } from '../../../../Services/APIService';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import { formatDate, formatDateTime } from '../../../../components/Common/Extensions';


function ActivationDetails({ dialogOpenClose, handleClose, handleSuccessClose, record, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({});
    const [beneficiariesList, setBeneficiariesList] = useState([]);
    const [isSIMActivationEnabled, setIsSIMActivationEnabled] = useState(false);
    const closeDialog = () => {
        handleClose();
    }

    const loadApplicationRecord = (applicationId) => {
        var params = {
            applicationId: applicationId
        }
        setIsLoading(true);
        PostDataAPI("fdnmcchromicconnect/getApplicationById", params, true).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                setState(result.data);
                setBeneficiariesList(result.data.programBeneficiaries)
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        });
    }

    const handleActivateChildClick = (index) => {
        const validBeneficiaries = beneficiariesList.filter(beneficiary => !beneficiary.isDeleted);
        const child = validBeneficiaries[index];

        //activate sim and get new number here
        var params = {
            applicationId: state.applicationId,
            iCC: child.icc,
            iMEI: child.deviceIdentification,
            cycleDay: new Date().getDate(),
            firstName: state.firstName,
            lastName: state.lastName,
            address1: state.address1,
            address2: state.address2,
            city: state.city,
            phone: state.phone,
            state: state.state,
            zip: state.zipCode,
            emailAddress: state.email,
            applyFor: state.applyFor,
            beneficiariesDTO: child
        }

        setIsLoading(true);
        PostDataAPI("fdnmcchromicconnect/activatePrepaidNumber", params, true).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                if (child) {
                    setBeneficiariesList((prevList) => {
                        if (index < 0 || index >= prevList.length) {
                            console.error('Index out of bounds');
                            return prevList;
                        }
                        return prevList.map((child, i) => {
                            if (i === index) {
                                return { ...child, ...result.data.beneficiariesDTO };
                            }
                            return child;
                        });
                    });
                }
                showMessage("Success", "SIM card activated successfully.", "success", 3000);
            } else {
                showMessage("Error", "Some error occurred in SIM card activation.", "error", 3000);
            }
        });

    }


    const handleActivateSelfClick = () => {
        //activate sim and get new number here
        var params = {
            applicationId: state.applicationId,
            iCC: state.icc,
            iMEI: state.deviceIdentification,
            cycleDay: new Date().getDate(),
            firstName: state.firstName,
            lastName: state.lastName,
            address1: state.address1,
            address2: state.address2,
            city: state.city,
            phone: state.phone,
            state: state.state,
            zip: state.zipCode,
            emailAddress: state.email
        }
        setIsLoading(true);
        PostDataAPI("fdnmcchromicconnect/activatePrepaidNumber", params, true).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                setState(prevState => ({
                    ...prevState,
                    assignedPhoneNumber: result.data.assignedPhoneNumber,
                    accountNumber: result.data.accountNumber,
                    activationDate: result.data.activationDate
                }));
                showMessage("Success", "SIM card activated successfully.", "success", 3000);
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        });

    }

    const loadSysCofigurationForSIMActivation = () => {
        var obj = { code: 'EnablePalmBeachSIMActivation' };
        PostDataAPI("sysconfig/getSysCofigurationByCode", obj).then((result) => {
            if (result.success && result.data != null) {
                var isEnabled = result.data.value == 'true' ? true : false;
                setIsSIMActivationEnabled(isEnabled);

            }
            else if (!result.message) {
                //showMessage("Error", result.message, "error", 3000);
            }
        });
    }

    useEffect(() => {

        loadSysCofigurationForSIMActivation();
        if (record && record.applicationId > 0) {
            loadApplicationRecord(record.applicationId)
        }

    }, []);





    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>

                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>{'Activation Details - ' + record?.firstName + (record?.middleName ? ' ' + record.middleName : '') + ' ' + record.lastName + ' | PB-' + (record.ssn || record.tin || '') + (state.version && state.version > 0 ? "-" + state.version : "")}</Typography>

                        <Icon className={classes.closeIcon} onClick={() => closeDialog()} color="primary"><CloseIcon /></Icon>
                    </div>
                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <Scrollbars autoHeight autoHeightMax={480}>
                        <div className={classes.content}>

                            <Grid container spacing={2} style={{ padding: '19px 0px 0px 0px' }}>
                                {
                                    state?.applyFor === 'Self' ? (
                                        <>
                                            <table className={classes.activationTable}>
                                                <tr className={'headerRow'}>
                                                    <th></th>
                                                    <th>Full Name</th>
                                                    <th>IMEI #</th>
                                                    <th>SIM Card #</th>
                                                    <th>Assigned Phone #</th>
                                                    <th>Activation Date</th>
                                                    <th className={'textCenter'}>Action</th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {state.assignedPhoneNumber && state.assignedPhoneNumber !== "null" && state.activationDate && state.assignedPhoneNumber.length > 0 ? <Tooltip title="SIM card activated"><SimCardIcon style={{ color: '#3ecb3e' }}></SimCardIcon></Tooltip> : <Tooltip title="SIM card not activated"><SignalCellularNoSimIcon style={{ color: '#a4a4a4' }}></SignalCellularNoSimIcon></Tooltip>}
                                                    </td>
                                                    <td>
                                                        {state.firstName}  {state.lastName}
                                                    </td>
                                                    
                                                    <td>
                                                        {state.deviceIdentification}
                                                    </td>
                                                    <td>
                                                        {state.icc}
                                                    </td>
                                                    <td>
                                                        {state.assignedPhoneNumber}
                                                    </td>
                                                    <td>
                                                        {state.activationDate ? formatDateTime(state.activationDate):''}
                                                    </td>
                                                    <td className={'textCenter'}>
                                                        <Button className={classes.activeMdn}
                                                            onClick={() => { handleActivateSelfClick() }}                                                            
                                                            disabled={!isSIMActivationEnabled ||
                                                                (!state.applicationId || state.applicationId == 0) ||
                                                                (state?.assignedPhoneNumber && state?.assignedPhoneNumber.length > 0)
                                                            }
                                                        >Activate</Button>
                                                    </td>
                                                </tr>
                                            </table>

                                        </>
                                    ) :
                                        (
                                            <>
                                                <table className={classes.activationTable}>
                                                    <tr className={'headerRow'}>
                                                        <th></th>
                                                        <th>Full Name</th>
                                                        <th>School Name</th>
                                                        <th>IMEI #</th>
                                                        <th>SIM Card #</th>
                                                        <th>Assigned Phone #</th>
                                                        <th>Activation Date</th>
                                                        <th className={'textCenter'}>Action</th>
                                                    </tr>

                                                    {
                                                        beneficiariesList?.map((child, index) => (
                                                            <tr>
                                                                <td>
                                                                    {child.assignedPhoneNumber && child.assignedPhoneNumber !== "null" && child.activationDate && child.assignedPhoneNumber.length > 0 ? <Tooltip title="SIM card activated"><SimCardIcon style={{ color: '#3ecb3e' }}></SimCardIcon></Tooltip> : <Tooltip title="SIM card not activated"><SignalCellularNoSimIcon style={{ color: '#a4a4a4' }}></SignalCellularNoSimIcon></Tooltip>}
                                                                </td>
                                                                <td>
                                                                    {child.firstName}  {child.lastName}
                                                                </td>
                                                                <td>
                                                                      {child.school == "null" || child.school == null || child.school == 'undefined' ? '': child.school}
                                                            
                                                                </td>
                                                                <td>
                                                                  {child.deviceIdentification == "null" || child.deviceIdentification == null || child.deviceIdentification == 'undefined' ? '': child.deviceIdentification}
                                                                </td>
                                                                <td>
                                                                      {child.icc == "null" || child.icc == null || child.icc == 'undefined' ? '': child.icc}
                                                                </td>
                                                                <td>
                                                                  {child.assignedPhoneNumber == "null" || child.assignedPhoneNumber == null || child.assignedPhoneNumber == 'undefined' ? '': child.assignedPhoneNumber}

                                                                </td>
                                                                <td>
                                                                    {child.activationDate ? formatDateTime(child.activationDate) : ''}
                                                                </td>

                                                                <td className={'textCenter'}>
                                                                    <Button className={classes.activeMdn}
                                                                        onClick={() => { handleActivateChildClick(index) }}
                                                                        disabled={!isSIMActivationEnabled ||
                                                                            (!state.applicationId || state.applicationId == 0) ||
                                                                            (child?.assignedPhoneNumber && child?.assignedPhoneNumber.length > 0)
                                                                        }
                                                                    >Activate</Button>
                                                                </td>

                                                            </tr>

                                                        ))
                                                    }
                                                </table>
                                            </>

                                        )}
                            </Grid>

                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={() => closeDialog()}>Close</Button>
                        </div>
                    </div>
                </div>
            </div>

        </Dialog >

    )
}

export default withSnackbar(ActivationDetails);
